import React from "react";
import LoginForm from "../components/LoginForm";
import { Link } from "react-router-dom";
import "../css/sign.css";

const Signin = () => {
  const FormHeader = (props) => <h2 id="headerTitle">{props.title}</h2>;
  const OtherMethods = (props) => (
    <div id="alternativeLogin">
      <Link className="nav-link" to="/register">Or Register</Link>
    </div>
  );

  return (
    <div className="container">
      <div id="loginform">
        <FormHeader title="Login" />
        <LoginForm />
        <OtherMethods />
      </div>
    </div>
  );
};

export default Signin;
